<div class="flex items-center justify-between">
  <div class="flex items-center gap-sm">
    <div
      class="square-chart-item"
      [class]="itemDotClass()"
      [style.background-color]="item().backgroundColor"></div>

    @if (
      item().label !== undefined && item().label !== null && item().label !== ''
    ) {
      @if (!showTooltip() || !item().tooltipData) {
        <div class="text-xs2 text-neutral-700 font-semibold">
          {{ item().label }}
        </div>
      } @else {
        <span
          libTooltip
          [toolTipTemplate]="toolTipTemplate"
          placement="top"
          [hasCloseIcon]="false"
          toolTipAction="mouseenter"
          [toolTipClass]="
            'bg-white p-md rounded-lg shadow-lg w-auto tooltip-arrow tooltip-arrow-top tooltip-alignment'
          "
          class="text-xs2 text-neutral-700 font-semibold">
          {{ item().label }}

          <ng-template #toolTipTemplate>
            <div class="text-xs font-medium text-neutral-900">
              {{ item().tooltipData }}
            </div>
          </ng-template>
        </span>
      }
    }
  </div>

  @if (
    (item().value !== undefined && item().value !== null) ||
    (item().percentage !== undefined && item().percentage !== null)
  ) {
    <div class="flex items-center gap-sm">
      @if (item().value !== undefined && item().value !== null) {
        <div class="text-xs text-neutral-900 font-medium">
          {{ item().value }}
        </div>
      }

      @if (item().percentage !== undefined && item().percentage !== null) {
        <div class="percentage-container flex items-center">
          <div
            class="text-xs text-neutral-700 font-medium px-sm rounded-full bg-neutral-100 inline-block">
            {{ item().percentage }}%
          </div>
        </div>
      }
    </div>
  }
</div>
